import { ObservationCycle } from 'types/api/envScales/ObservationCycle';
import { Assessment } from 'types/api/envScales/Assessment';
import { AgeLevel } from 'types/api/envScales/AgeLevel';
import { CycleMetaDataValue } from 'types/api/envScales/CycleMetaDataValue';
import MetaDataCategoryForm from '../MetaDataCategoryForm/MetaDataCategoryForm';

interface SecondEditionMetaDataContentProps {
  /** Observation Cycle. */
  cycle: ObservationCycle;

  /** CLASS Assessment. */
  assessment: Assessment;

  /** Environmental Scales Age Level. */
  ageLevel: AgeLevel;

  /** Observation ID */
  observationId: number;

  /** Meta data values */
  values: CycleMetaDataValue[];
}

/**
 * Renders metadata content specific to standard Second Edition assessments
 */
function SecondEditionMetaDataContent({
  cycle,
  ageLevel,
  observationId
}: SecondEditionMetaDataContentProps) {
  const categoriesClassSecondEdition = ageLevel.meta_data_categories
    .filter(category => category.assessment_template.class_version === 2)
    .filter(category => category.choices.length > 0);

  return (
    <div className="mt-16">
      <MetaDataCategoryForm
        categories={categoriesClassSecondEdition}
        cycle={cycle}
        observationId={observationId}
      />
    </div>
  );
}

export default SecondEditionMetaDataContent;
